<app-ged-results-sort-selector *ngIf="checkIfVisible(CheckKey.SORTKEY)"
                           (changeSortAction)="changeSort($event)"
                           [objectType]="objectType"
                           [entityFolder]="entityType"
                           [selectedSortKey]="sortKey"
                           [selectedSortLabel]="sortLabel"
                           [selectedSortDirection]="sortDirection"
                           [screenWidth]="screenWidth">
</app-ged-results-sort-selector>
<div class="leftPart">
  <app-results-count class="resultCount" [esPage]="esPage"  *ngIf="!!esPage"></app-results-count>
  <app-results-pagesize *ngIf="checkIfVisible(CheckKey.PAGESIZE)"
                        (changePageSizeAction)="changePageSize($event)"
                        [objectType]="objectType"
                        [selectedValue]="pageSize"
                        [screenWidth]="screenWidth">
  </app-results-pagesize>
</div>
